(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kopstorm-about-charity"] && !window.DesignMode) return;
  try {
    
// Optional: JavaScript can be added here if needed

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kopstorm-about-commitment"] && !window.DesignMode) return;
  try {
    
// Optional: JavaScript can be added here if needed

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kopstorm-about-doctor-V2"] && !window.DesignMode) return;
  try {
    
// Optional: JavaScript can be added here if needed

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kopstorm-about-dr"] && !window.DesignMode) return;
  try {
    
// Optional: JavaScript can be added here if needed

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kopstorm-about-founder-V2"] && !window.DesignMode) return;
  try {
    
// Optional: JavaScript can be added here if needed

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kopstorm-about-grid"] && !window.DesignMode) return;
  try {
    
// Optional: JavaScript can be added here if needed

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kopstorm-about-timeline"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Function to check if an element is in viewport
  function isInViewport(element) {
    const rect = element.getBoundingClientRect();
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
    
    // Element is in viewport if it's in the bottom 80% of the screen
    const inView = rect.top <= windowHeight * 0.8;
    
    // Element is out of viewport if it's below the top 20% of the screen
    const outOfView = rect.top > windowHeight * 0.2;
    
    return { inView, outOfView };
  }
  
  // Function to reveal and hide timeline items when scrolled
  function handleTimelineItems() {
    const timelineItems = document.querySelectorAll('.timeline-item');
    
    timelineItems.forEach((item, index) => {
      // Skip the first two items (always visible)
      if (index < 2) return;
      
      const { inView, outOfView } = isInViewport(item);
      
      // If the item should be visible
      if (inView) {
        if (!item.classList.contains('reveal')) {
          item.classList.add('reveal');
          setTimeout(() => {
            item.classList.remove('hidden-milestone');
          }, 800); // Match the transition duration
        }
      } 
      // If the item should be hidden (smooth reverse)
      else if (outOfView) {
        if (!item.classList.contains('hidden-milestone')) {
          item.classList.remove('reveal');
          setTimeout(() => {
            item.classList.add('hidden-milestone');
          }, 800); // Match the transition duration
        }
      }
    });
  }
  
  // Initial check on load
  setTimeout(handleTimelineItems, 100);
  
  // Check on scroll with throttling for performance
  let scrollTimeout;
  window.addEventListener('scroll', function() {
    if (!scrollTimeout) {
      scrollTimeout = setTimeout(function() {
        handleTimelineItems();
        scrollTimeout = null;
      }, 10);
    }
  }, { passive: true });
  
  // Also check on resize
  window.addEventListener('resize', handleTimelineItems, { passive: true });
});

  } catch(e) { console.error(e); }
})();
})();
